export const determineAriaLabel = (name: string): string => {
  if (name === 'AnyConnect') return 'Edit Cisco Secure Client Node';

  return `Edit ${name} Node`;
};
